import { React, useState } from "react";
import { Link } from "react-router-dom";
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import ClassifyIcon from "../../../../images/classify_96px.png";
import HoverClassifyIcon from "../../../../images/classify_96px_orange.png";
import RegressionIcon from "../../../../images/regression_boldgrey_96px.png"
import HoverRegressionIcon from "../../../../images/regression_orange.png"
import ClusteringIcon from "../../../../images/cluster_darkgrey_96px.png"
import HoverClusteringIcon from "../../../../images/cluster_orange.png"
import Button from "../../../../components/PrimaryButton.js";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    height: "50%",
  },
  mainContainer: {
    margin: " 10% 60px 0 60px",
    height: "100%",
  },
  paper: {
    height: "100%",
    textAlign: "center",
    position: "relative",
    cursor: "pointer",
  },
  icons: {
    width: "30%",
    marginTop: "15%",

  },
  hoveringIcon: {
    position: "absolute",
    right: "35%",
    opacity: 0,
    transition: "opacity .2s",
    "&:hover": {
      opacity: 1,
    }
  },
  selectedIcon: {
    position: "absolute",
    right: "35%",
  },
  button: {
    position: "absolute",
    right: "5%",
    bottom: 20,
  }
}));

const Model = () => {
  const classes = useStyles();
  const [selectedObj, setSelectedObj] = useState("");
  return (
    <>
      <div className={classes.mainContainer}>
        <h3 style={{ marginBottom: 20, marginLeft: 1 }}>Select and objective</h3>
        <Grid container className={classes.root} justify="center" spacing={3} >
          <Grid item xs={4}>
            <Paper elevation={2}
              className={classes.paper}
              onClick={() => {
                setSelectedObj("classify");
              }}
              style={{
                border: `${selectedObj === "classify" ? "2px solid #FF7E67" : "none"}`,
              }}>
              <img className={classes.icons} src={ClassifyIcon} alt="classify-icon" />
              <img className={`${classes.icons} ${classes.hoveringIcon}`} src={HoverClassifyIcon} alt="hover-classify-icon" />
              {selectedObj === "classify" && <img className={`${classes.icons} ${classes.selectedIcon}`} src={HoverClassifyIcon} alt="hover-classify-icon" />}
              <h3>Classify</h3>
            </Paper>
          </Grid>
          <Grid item xs={4}>
            <Paper elevation={2} className={classes.paper}
              onClick={() => {
                setSelectedObj("regress");
              }}
              style={{
                border: `${selectedObj === "regress" ? "2px solid #FF7E67" : "none"}`,
              }}>
              <img className={classes.icons} src={RegressionIcon} alt="regression-icon" />
              <img className={`${classes.icons} ${classes.hoveringIcon}`} src={HoverRegressionIcon} alt="hover-regression-icon" />
              {selectedObj === "regress" && <img className={`${classes.icons} ${classes.selectedIcon}`} src={HoverRegressionIcon} alt="hover-regression-icon" />}
              <h3>Regress</h3>
            </Paper>
          </Grid>
          <Grid item xs={4}>
            <Paper elevation={2} className={classes.paper}
              onClick={() => {
                setSelectedObj("cluster");
              }}
              style={{
                border: `${selectedObj === "cluster" ? "2px solid #FF7E67" : "none"}`,
              }}>
              <img className={classes.icons} src={ClusteringIcon} alt="clustering-icon" />
              <img className={`${classes.icons} ${classes.hoveringIcon}`} src={HoverClusteringIcon} alt="hover-clustering-icon" />
              {selectedObj === "cluster" && <img className={`${classes.icons} ${classes.selectedIcon}`} src={HoverClusteringIcon} alt="hover-clustering-icon" />}
              <h3>Cluster</h3>
            </Paper>
          </Grid>
        </Grid>
        <Link to={`/methods/new-method/model/${selectedObj}`}>
          <Button styleClasses={classes.button} isDisabled={!selectedObj} innerText="Next"></Button>
        </Link>
      </div>
    </>
  );
};

export default Model;
